module.exports = __webpack_public_path__ + "static/media/TeamWorkGameMill01.24905224.png";